export const resourceType = [
  {
    name: "住",
    name1: "酒店",
    typeName: "hotel",
    title: "酒店资源",
    maintain: "房型维护",
    code: 0,
  },
  {
    name: "会",
    name1: "会议",
    typeName: "site",
    title: "会议资源",
    maintain: "会场维护",
    code: 1,
  },
  {
    name: "景",
    name1: "景点",
    typeName: "spot",
    title: "景点资源",
    maintain: "景点产品维护",
    code: 2,
  },
  {
    name: "车",
    name1: "用车",
    typeName: "traffic",
    title: "用车资源",
    maintain: "用车维护",
    code: 3,
  },
  {
    name: "餐",
    name1: "用餐",
    nameEn: "restaurant",
    title: "用餐资源",
    code: 4,
  },
  {
    name: "导",
    name1: "导游",
    typeName: "guide",
    title: "导游资源",
    maintain: "导游维护",
    code: 5,
  },
  {
    name: "签",
    name1: "签证",
    typeName: "visa",
    title: "签证资源",
    maintain: "签证维护",
    code: 6,
  },
  {
    name: "商",
    name1: "商务",
    typeName: "business",
    title: "商务资源",
    maintain: "商务维护",
    code: 7,
  },
  {
    name: "特",
    name1: "特色",
    typeName: "charact",
    title: "特色资源",
    maintain: "特色维护",
    code: 8,
  },
  {
    name: "服",
    name1: "服务",
    typeName: "service",
    title: "特色资源",
    maintain: "特色维护",
    code: 9,
  },
  {
    name: "交",
    name1: "交通",
    typeName: "plane",
    title: "交通资源",
    maintain: "交通维护",
    code: 15,
  },
];

//分组
export function getGroup(data, key) {
  let groups = {};
  data.forEach((c) => {
    let value = c[key];
    groups[value] = groups[value] || [];
    groups[value].push(c);
  });
  return groups;
}
// 去重
export function duplicateRemoval(data, field) {
  var fields = [];
  var arr = [];
  for (var i = 0; i < data.length; i++) {
    if (fields.indexOf(data[i][field]) == -1) {
      fields.push(data[i][field]);
      arr.push(data[i]);
    }
  }
  return arr;
}
//日期排序
export function sortByCreateTime(array) {
  if (array.length > 1) {
    return array.sort((a, b) => {
      const dateA = new Date(a.createTime);
      const dateB = new Date(b.createTime);
      return dateB - dateA;
    });
  } else {
    return array;
  }
}
//防抖
export function debounce(func, delay) {
  let timerId;
  return function (...args) {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
function convertToHyphenFormat(dateString) {
  const hyphenFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!hyphenFormatRegex.test(dateString)) {
    return dateString.replace(/\./g, "-");
  }
  return dateString;
}
//计算天数
export function days(satrDate, endDate, type) {
  let star = new Date(convertToHyphenFormat(satrDate));
  let end = new Date(convertToHyphenFormat(endDate));
  let timeDiff = Math.abs(end.getTime() - star.getTime());
  let stayDays;
  stayDays = timeDiff / (1000 * 3600 * 24);
  return stayDays;
}

//转换日期
export function conversionDate(dateStr) {
  return dateStr.replace(/\./g, '-');
}
//日期加1
export function addOneDay(dateStr) {
  // 将日期字符串转换为标准日期格式
  const formattedDate = dateStr.replace(/\./g, '-');
  
  // 加一天
  const currentDate = new Date(formattedDate);
  currentDate.setDate(currentDate.getDate() + 1);

  // 格式化新日期
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');

  const newFormattedDate = `${year}-${month}-${day}`;

  return newFormattedDate;
}
//计算天数
export function calculateDaysDifference(startDate, endDate) {
  const startDateObj = new Date(startDate);
  const endDateObj = new Date(endDate);
  const timeDifference = endDateObj - startDateObj;
  const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
  return daysDifference;
}
export function dateFormatHm(originVal) {
  const dt = new Date(originVal);
  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getDate() + "").padStart(2, "0");

  const hh = (dt.getHours() + "").padStart(2, "0");
  const mm = (dt.getMinutes() + "").padStart(2, "0");

  return `${y}-${m}-${d} ${hh}:${mm}`;
}
export function dateFormat(originVal) {
  const dt = new Date(originVal);
  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getDate() + "").padStart(2, "0");
  return `${y}-${m}-${d}`;
}
//去重
export function uniqueByProperty(arr, property) {
  return Object.values(
    arr.reduce((acc, item) => {
      acc[item[property]] = item;
      return acc;
    }, {})
  );
}
//文件下载
export function download(ulrs, name) {
  fetch(ulrs).then((res) => {
      res.blob().then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = name;
          a.click()
          window.URL.revokeObjectURL(url)

      })
  })
}